"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInputReadonly = exports.getFormModalType = exports.openStatusModal = void 0;
const model_1 = require("../model");
const types_1 = require("../model/types");
/**

 * @param modalType 標示類型
 * @param message 打開 statusModal 附加訊息
 * @returns
 */
const openStatusModal = (modalType, message) => {
    return (0, model_1.SET_IS_STATUS_MODAL_OPEN)({
        statusModalType: types_1.StatusModalTypes[modalType],
        isOpen: true,
        message
    });
};
exports.openStatusModal = openStatusModal;
const getFormModalType = (pageRoutes) => {
    if (pageRoutes.editFormModal.isOpen)
        return types_1.FormModalTypes.EDIT_FORM;
    if (pageRoutes.viewFormModal.isOpen)
        return types_1.FormModalTypes.VIEW_FORM;
};
exports.getFormModalType = getFormModalType;
const isInputReadonly = (pageRoutes) => {
    if (pageRoutes.editFormModal.isOpen)
        return false;
    if (pageRoutes.viewFormModal.isOpen)
        return true;
};
exports.isInputReadonly = isInputReadonly;
